// src/chains/polygon.js - Polygon Mainnet configuration with SushiSwap API support
import { createChainConfig } from './chainConfig';

export const polygonConfig = createChainConfig({
  key: 'polygon',
  chainId: 137,
  name: 'Polygon Mainnet',
  rpcUrl: 'https://polygon-rpc.com',
  explorerUrl: 'https://polygonscan.com',
  
  // Native token information
  nativeTokenSymbol: 'POL',
  nativeTokenName: 'Polygon',
  nativeTokenIcon: 'https://i.imgur.com/CRGSDZe.png', // POLYGON icon URL
  nativeTokenDecimals: 18,
  
  // Related token addresses
  wrappedNativeToken: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270', // WMATIC address
  
  // Price and API endpoints
  coingeckoAPI: 'https://api.coingecko.com/api/v3/simple/price?ids=matic-network&vs_currencies=usd&include_24hr_change=true',
  coingeckoId: 'matic-network',
  geckoTerminalId: 'polygon',
  tokenListUrl: 'https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/polygon.json',
  
  // SushiSwap configuration
  aggregatorAddress: 'SushiSwap',
  sushiswapConfig: {
    apiBaseUrl: 'https://api.sushi.com',
    routerAddress: '0xAC4c6e212A361c968F1725b4d055b47E63F80b75' // Polygon SushiSwap router
  },
  
  // Legacy aggregator reference
  legacyAggregatorAddress: '0x546b4c3916A5A2d9D6F6D331E0a9D6aD2C754b39', // Example legacy address
  
  // Transaction support
  supportsEIP1559: true,
  
  // Transaction history API
  txHistoryApi: 'https://api.routescan.io/v2/network/mainnet/evm/137/address/{address}/transactions'
});